export const ACCOUNT = 'account-logged-in-user';
